import cloneDeep from "lodash/cloneDeep";

import EventManager from "../../../store/sqftEventManager";
import config from "../../../store/sqftConfig";
import {
  getPointDistance,
  measureDistanceToInches,
  getFontsize, getAngleBetweenTwoPoints, getParallelPoints, getPointField
} from "../../../../../helpers/sqftHelper";
import {pnpolyArray} from "../../../../../lib/pnpoly";
import store from "../../../../../../../store";
import {setSQFTContextMenu} from "../../../../../../../actions/sqftMenuFunctions";
import {iconGreenClip} from "../../../../../assetsSQFT";
import sqftShape from "../sqftShape";
import {SIDEBAR_BUTTONS_MENU} from "../../../../../constants";
import {COLOR} from "../../../store/colorThemes";

export default function(initialState = {}) {
  let self = this,
    state = {
      ...{
        labelText: '',
        labelTextColor: '#3e3e3e',
        textWidth: 0,
        isHovered: false,
        imageSrc: iconGreenClip,
        lineOffset: 13,
        flagMargin: 2,
        partId: undefined,
        isTitle: false,
        midPoint: {
          x: 0,
          y: 0
        }
      },
      ...initialState
    },
    line = null,
    shape = null;

  const svgCache = {};

  function setLine(value) { line = value; }
  function setShape(value) { shape = value; }
  function getMidPoint(from, to) {
    return {
      x: from.x + (to.x - from.x)/2,
      y: from.y + (to.y - from.y)/2
    };
  }
  function onMouseMove(mousePos, e) {
    void e;
    const {isHovered, orientation} = isMouseOverText(mousePos);
    state.isHovered = isHovered;
    if (state.isHovered) {
      if (EventManager.getCursor().indexOf("move") >= 0) {
        EventManager.stealCursor(true);
        EventManager.setCursor((orientation === "horizontal") ? "text" : "text-vertical", self);
      }
    } else {
      EventManager.resetCursor(self);
    }
  }
  function onMouseDown(mousePos, e) {
    if (state.isHovered) {
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;

      //Delete label
      if (activeButton !== SIDEBAR_BUTTONS_MENU.delete) {
        void e;
        window.lineInputFocused = false;
        EventManager.stealCursor();
        EventManager.resetCursor(self);

        store.dispatch(setSQFTContextMenu({isOpened: true, activeMenu: "labels", pos: mousePos, parent: shape}));
      }

      return true
    }
  }
  function isMouseOverText(mousePos) {
    const lineDirection = line.getLineDirection();
    let pointsArray = [];
    let lineOffset = [];
    if (lineDirection.orientation === "horizontal") {
      lineOffset = lineDirection.newDirection === "west" ? -state.lineOffset : state.lineOffset;
      pointsArray = [
        [state.midPoint.x - state.textWidth/2 - 10, state.midPoint.y - 15 + lineOffset],
        [state.midPoint.x + state.textWidth/2 + 10, state.midPoint.y - 15 + lineOffset],
        [state.midPoint.x + state.textWidth/2 + 10, state.midPoint.y + 10 + lineOffset],
        [state.midPoint.x - state.textWidth/2 - 10, state.midPoint.y + 10 + lineOffset],
      ]
      // pointsArray.forEach(p => {
      //   var tempPoint = new point(p[0], p[1]);
      //   tempPoint.init(line);
      //   tempPoint.layout = 'white-circle';
      //   debugger
      // })
    } else if (lineDirection.orientation === "vertical") {
      if (lineDirection.newDirection === "south") {
        pointsArray = [
          [state.midPoint.x + 40, state.midPoint.y - state.textWidth/2 - 10],
          [state.midPoint.x + 15, state.midPoint.y - state.textWidth/2 - 10],
          [state.midPoint.x + 15, state.midPoint.y + state.textWidth/2 - 5],
          [state.midPoint.x + 40, state.midPoint.y + state.textWidth/2 - 5],
        ];
      } else if (lineDirection.newDirection === "north") {
        pointsArray = [
          [state.midPoint.x - 40, state.midPoint.y - state.textWidth/2 - 10],
          [state.midPoint.x - 15, state.midPoint.y - state.textWidth/2 - 10],
          [state.midPoint.x - 15, state.midPoint.y + state.textWidth/2 - 5],
          [state.midPoint.x - 40, state.midPoint.y + state.textWidth/2 - 5],
        ];
      }
    } else {
      // todo rotation hover
    }
    return {isHovered: pnpolyArray(pointsArray, mousePos), orientation: lineDirection.orientation};
  }

  this.getState = () => { return state }
  this.isHovered = () => { return state.isHovered }
  this.destroy = function(protect) {
    if(!protect) {
      EventManager.removeEvent(self);
    }
  };
  this.getParent = () => {
    return line
  }
  this.setLabelText = (value) => {
    state.labelText = value;
  };
  this.setPartId = (value) => {
    state.partId = value;
  };
  this.import = function(data) {
    state = data.state;
  };
  this.export = function() {
    return { state: cloneDeep(state) }
  };
  this.init = function(line, text, partId) {
    setLine(line);
    //todo sqft-react
    setShape(line.getParent());
    void shape;

    this.setPartId(partId);
    this.setLabelText(text);
    this.initEvents(!state.isTitle);
  };
  this.initEvents = (editable = true) => {
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render,
      this,
      EventManager.priorities.SHAPE_LABEL
    );
    if (editable) {
      EventManager.addEvent(
        EventManager.events.MOUSE_MOVE,
        onMouseMove,
        this,
        EventManager.priorities.SHAPE_LABEL
      );
      EventManager.addEvent(
        EventManager.events.MOUSE_DOWN,
        onMouseDown,
        this,
        EventManager.priorities.SHAPE_LABEL
      );
    }
  }
  this.deregisterEvents = () => {
    EventManager.removeEvent(this);
  };
  this.reInitEvents = () => {
    this.initEvents(!state.isTitle);
  };
  this.deregisterPartEvents = () => {
    EventManager.removeEvent(this);
  };
  this.reInitPartEvents = () => {
    this.initEvents(!state.isTitle);
  };
  this.getLineLength = function () {
    var distance = getPointDistance(line.from, line.to);
    return measureDistanceToInches(distance);
  };
  this.isIE = function() {
    return(/Trident/i).test(window.navigator.appVersion);
  };
  this.getSrc = function(img) {
    if(img) {
      let src = img.getAttribute('src');
      if(src) {
        return src;
      }
      src = img.getAttribute("style");
      if(src) {
        return src.replace(/background-image: url\("\/api\/SqFtCalc\/GetImage\?url=/g, "").replace(/"\);/g, "");
      }
    }
    return "";
  };

  this.renderImage = (ctx, x, y) => {
    if (state.isTitle) return;

    let scale = config.scale;
    let size = { width: 5, height: 5 };
    let posX = x - size.width * scale;
    let posY = y - size.height * scale;

    if (svgCache['iconGreenClip']) {
      let img = svgCache['iconGreenClip'];
      ctx.drawImage(img, posX, posY, size.width * scale, size.height * scale);
    } else {
      let img = new Image();
      let svg = document.getElementById('icon-label-flag');

      if (svg) {
        let xml = new XMLSerializer().serializeToString(svg);
        let svg64 = btoa(xml);

        img.src = 'data:image/svg+xml;base64,' + svg64;

        img.onload = () => {
          svgCache['iconGreenClip'] = img;
          ctx.drawImage(img, posX, posY, size.width * scale, size.height * scale);
        };

        img.onerror = () => {
          console.warn("Failed to load SVG image, using fallback.");
          // ctx.fillStyle = '#FF0000'; // Фолбек в виде красного квадрата
          // ctx.fillRect(x - 10, y - 10, 20, 20);
        };
      }
    }
  };

  this.render = function(ctx) {
    let scale = config.scale,
      fontSize = getFontsize(),
      font = (fontSize).toString() + "px " + config.activeFontBold,
      lineDirection = line.getLineDirection(),
      offset = line.getOffset(),
      dString = state.labelText,
      midPoint = getMidPoint(line.from, line.to),
      mText,
      lineOffset = 0,
      xOffset = 0,
      marginTo = 0;

    ctx.beginPath();

    ctx.font        = font;
    mText           = ctx.measureText(dString);
    state.textWidth = Math.round(mText.width * 100) / 100;
    midPoint.y      = midPoint.y * scale + offset.y;
    midPoint.x      = midPoint.x * scale + offset.x;
    state.midPoint.x = midPoint.x;
    state.midPoint.y = midPoint.y;
    ctx.textAlign   = "center";
    midPoint.y      += fontSize / 2;

    ctx.beginPath();
    ctx.fillStyle = state.isHovered ? COLOR.red : state.labelTextColor;

    let moveFrom, moveTo;

    switch (lineDirection.orientation) {
      case "horizontal": {
        lineOffset = lineDirection.newDirection === "west" ? -state.lineOffset : state.lineOffset;
        ctx.wrapText(dString, midPoint.x, midPoint.y + lineOffset, mText, fontSize);
        this.renderImage(ctx,midPoint.x - mText.width / 2 - state.flagMargin, midPoint.y + lineOffset);
        break;
      }
      case "vertical": {
        if (lineDirection.newDirection === "south") {
          marginTo = (lineDirection.cornerMargins.fromBottom) ? marginTo + 9 : marginTo;
        } else if (lineDirection.newDirection === "north") {
          marginTo = (lineDirection.cornerMargins.fromTop) ? marginTo + 9 : marginTo;
        }
        ctx.save();
        ctx.translate(
          lineDirection.newDirection === "south" ? midPoint.x + xOffset : midPoint.x + xOffset,
          lineDirection.newDirection === "south" ? midPoint.y - 5 : midPoint.y - 10
        );
        ctx.rotate(lineDirection.newDirection === "south" ? Math.PI / 2 : -Math.PI / 2);
        lineOffset = lineDirection.newDirection === "south" ? state.lineOffset  : state.lineOffset ;

        ctx.wrapText(dString, marginTo,lineOffset + fontSize, mText, fontSize);
        this.renderImage(ctx,marginTo - mText.width / 2, lineOffset + fontSize);
        break;
      }
      //todo
      case "NORTHWEST":
      case "NORTHEAST":
      case "SOUTHWEST":
      case "SOUTHEAST": {
        ctx.save();
        const mText = ctx.measureText(dString);
        const angle = getAngleBetweenTwoPoints(line.from, line.to);
        [moveFrom, moveTo] = getParallelPoints(line.from, line.to, 6);
        const midPoint = getMidPoint(moveFrom, moveTo);
        //todo not sure why shape here becomes null after clicking on eyeball
        if (!(shape instanceof(sqftShape))) {
          shape = line.getParent();
        }
        const midPointPointField = getPointField(midPoint.x, midPoint.y, shape);
        ctx.save();
        ctx.translate(
          midPointPointField.x,
          midPointPointField.y,
        );
        ctx.rotate(angle * (Math.PI / 180));

        ctx.wrapText(dString, 0, 0, mText, fontSize);
        this.renderImage(ctx,0 - mText.width / 2, 0);

        break;
      }
      default:
        break;
    }

    ctx.restore();
  };
}
